var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,24C5.383,24,0,18.617,0,12S5.383,0,12,0s12,5.383,12,12-5.383,12-12,12ZM12,1C5.935,1,1,5.935,1,12s4.935,11,11,11,11-4.935,11-11S18.065,1,12,1Zm2.888,18c-4.343,0-9.888-5.544-9.888-9.888,0-.945,.358-1.824,1.008-2.473l1.847-1.846,3.645,3.645-2.039,2.04c.853,1.938,2.185,3.273,4.059,4.067l2.043-2.043,3.646,3.645-1.846,1.846c-.649,.65-1.527,1.008-2.474,1.008ZM7.854,6.207l-1.14,1.139c-.461,.461-.715,1.088-.715,1.766,0,3.821,5.066,8.888,8.888,8.888,.679,0,1.306-.254,1.767-.715l1.139-1.139-2.231-2.231-1.799,1.799-.303-.115c-2.372-.906-4.072-2.605-5.055-5.051l-.123-.307,1.803-1.803-2.23-2.231Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePhone);
export default __webpack_public_path__ + "static/media/circle-phone.c4dad90b1983d09dc277c701df518ab6.svg";
export { ForwardRef as ReactComponent };